export default "__VITE_ASSET__b17a2d0c__"